import { DATABASE_VERSION, DB_NAME, USER_CACHE_DB_NAME } from "./constants";

export const openUserCache = async (): Promise<IDBDatabase> => {
	const request = indexedDB.open(USER_CACHE_DB_NAME, DATABASE_VERSION);

	return new Promise<IDBDatabase>((resolve, reject) => {
		request.onerror = () => {
			console.error("Database error: " + request.error);
			reject(request.error);
		};

		request.onsuccess = () => resolve(request.result);

		request.onupgradeneeded = () => {
			const db = request.result;
			if (!db.objectStoreNames.contains(DB_NAME)) {
				db.createObjectStore(DB_NAME);
				console.info("Created " + DB_NAME);
			}
		};
	});
};
